<template>
  <div class="menu">
    <div class="menu__item" v-for="(item, index) in menuItems" :key="index"
      @click="handleItemClick(item.value)">
      <div class="menu__item-text">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleItemClick (value) {
      this.$emit('item-click', value);
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.menu {
	background: #161518;
	border-radius: rem(16);
	border-style: solid;
	border-color: rgba(255, 255, 255, 0.1);
	border-width: 1px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: rem(200);
	position: relative;
	overflow: hidden;

	&__item {
		opacity: 0.6;
		padding: rem(12) rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(10);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		height: rem(40);
		position: relative;
		cursor: pointer;

		&:not(:last-child)::after {
			content: '';
			background: #ffffff;
			opacity: 0.1;
			align-self: stretch;
			height: rem(1);
			position: absolute;
			bottom: 0;
			left: rem(20);
			right: rem(20);
		}

		&:hover {
			opacity: 1;
		}

		&-text {
			color: #ffffff;
			text-align: left;
			font-size: rem(12);
			line-height: rem(12);
			font-weight: 400;
			position: relative;
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.menu {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.menu {
		width: 100%;

		&__item {
			padding: rem(12) rem(16);
		}
	}
}
</style> 